import React, { Component } from 'react';
import OgaTable from "components/OgaTables/OgaTable";

import { connect } from "react-redux";

import moment from "moment";

import {
    fetchSaleOrders,
    updateFilterCustomer,
    updateFilterOrderStatus,
    updateFilterStartDate,
    updateFilterEndDate
} from "reducers/saleorders/saleordersActions";

import CustomerTypeahead from 'components/Typeaheads/CustomerTypeahead';
import OrderStatusSelect from 'components/OrderStatusSelect/OrderStatusSelect';
import NoInfo from 'components/NoInfo/NoInfo';


import { Row, Col, FormGroup } from "react-bootstrap";
import DatetimeRangePicker from 'react-datetime-range-picker';

import { Button } from "react-bootstrap";

import history from 'routes/History/history';

class Sales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            quantityRows: 10
        };
    }

    componentWillMount() {
        this.loadSaleOrders(1, null, null, this.props.filterStartDate, this.props.filterEndDate);
    }

    loadSaleOrders(pageNumber, customerId, status, startDate, endDate) {
        this.setState({ loading: true });
        let promise = new Promise((resolve, reject) => {

            let requestData = {
                quantityRows: this.state.quantityRows,
                pageNumber: pageNumber,
                customerId: customerId,
                status: status,
                startDate: startDate === "" ? null : startDate,
                endDate: endDate === "" ? null : endDate
            }

            this.props.fetchSaleOrders(requestData, resolve, reject);
        });
        promise.then(() => {
            this.setState({ loading: false });
        });
    }

    onPageChange = (pageNumber) => {
        this.loadSaleOrders(pageNumber + 1, this.props.filterCustomer != null ? this.props.filterCustomer.id : null,
            this.props.filterOrderStatus, this.props.filterStartDate, this.props.filterEndDate);
    }

    handleProductEdit = (row) => {
        history.push({ pathname: "/sale-product", search: "?saleOrderId=" + row.id + "&orderStatus=" + row.orderStatus });
    }

    handleNegotiation = (row) => {
        history.push({ pathname: "/sale-negotiate", search: "?saleOrderId=" + row.id + "&orderStatus=" + row.orderStatus });
    }

    isNegotiationEditable = (orderStatus) => {
        if (orderStatus) {
            return orderStatus === 'DRAFT';
        }
        return true;
    }

    isProductEditable = (orderStatus) => {
        if (orderStatus) {
            return orderStatus === 'DRAFT';
        }
        return true;
    }

    getMapActionLabel = (row) => {
        return this.isProductEditable(row.orderStatus) ? "Editar Lote" : "Ver Lote";
    }

    getNegotiationActionLabel = (row) => {
        return this.isNegotiationEditable(row.orderStatus) ? "Editar Negociación" : "Ver Negociación";
    }

    handleCustomerSelectionChange(selectedCustomer) {
        this.props.updateFilterCustomer(selectedCustomer);
        let customerId = selectedCustomer != null ? selectedCustomer.id : null;
        this.loadSaleOrders(1, customerId, this.props.filterOrderStatus, this.props.filterStartDate, this.props.filterEndDate);
    }

    handleOrderStatusChange(orderStatus) {
        let value = orderStatus != null ? orderStatus.value : null;
        this.props.updateFilterOrderStatus(value);
        this.loadSaleOrders(1, this.props.filterCustomer != null ? this.props.filterCustomer.id : null,
            value, this.props.filterStartDate, this.props.filterEndDate);
    }

    handleStartDateChange(date) {
        console.log("handleStartDateChange", date);
        let value = typeof date === 'string' ? "" : moment(date).format('DD/MM/YYYY');
        this.props.updateFilterStartDate(value);
        this.loadSaleOrders(1, this.props.filterCustomer != null ? this.props.filterCustomer.id : null,
            this.props.filterOrderStatus, value, this.props.filterEndDate);
    }

    handleEndDateChange(date) {
        let value = typeof date === 'string' ? null : moment(date).format('DD/MM/YYYY');
        this.props.updateFilterEndDate(value);
        this.loadSaleOrders(1, this.props.filterCustomer != null ? this.props.filterCustomer.id : null,
            this.props.filterOrderStatus, this.props.filterStartDate, value);
    }

    goToNewAffiliation() {
        history.push("sale");
    }

    render() {
        return (
            <div>
                <div>
                    <Row>
                        <Col md={4}>
                            <FormGroup >
                                <CustomerTypeahead
                                    onRef={ref => (this.customerTypeahead = ref)}
                                    selection={this.props.filterCustomer}
                                    handleChange={(customer) => this.handleCustomerSelectionChange(customer)} />
                            </FormGroup >
                        </Col>
                        <Col md={4}>
                            <FormGroup >
                                <OrderStatusSelect
                                    selection={this.props.filterOrderStatus}
                                    handleChange={(orderStatus) => this.handleOrderStatusChange(orderStatus)}
                                />
                            </FormGroup >
                        </Col>

                    </Row>

                    <FormGroup >
                        <DatetimeRangePicker
                            dateFormat={"DD/MM/YYYY"}
                            inputProps={{ className: "form-control form-control-sm", placeholder: "Seleccione rango de fechas" }}
                            onChange={this.handler}
                            timeFormat={false}
                            className="row"
                            pickerClassName="col-md-4 form-group"
                            onStartDateChange={(moment) => this.handleStartDateChange(moment)}
                            onEndDateChange={(moment) => this.handleEndDateChange(moment)}
                            startDate={this.props.filterStartDate}
                            endDate={this.props.filterEndDate}
                        />
                    </FormGroup >
                </div>


                <div className="d-flex flex-row-reverse">
                    <FormGroup>
                        <Button className="bg-light-secondary"
                            onClick={() => this.goToNewAffiliation()}>Nueva Afiliación</Button>
                    </FormGroup>
                </div>


                {this.props.saleOrdersDto !== null &&
                    <div>
                        {this.props.saleOrdersDto.data.length > 0 ?
                            <OgaTable
                                loading={this.state.loading}
                                headers={["Nro.", "Fecha de creación", "Proyecto", "Producto", "Precio", "Cliente", "Modalidad", "Estado"]}
                                properties={["id", "date", "commercialProject", "product", "finalPrice", "customer", "conditionType", "orderStatusLabel"]}
                                pullRight={[4]}
                                pageCount={this.props.saleOrdersDto.count}
                                onPageChange={this.onPageChange}
                                actions={[
                                    {
                                        icon: "map",
                                        handler: this.handleProductEdit,
                                        tooltip: this.getMapActionLabel
                                    },
                                    {
                                        icon: "attach_money",
                                        handler: this.handleNegotiation,
                                        tooltip: this.getNegotiationActionLabel
                                    },
                                ]}
                                values={this.props.saleOrdersDto.data} />
                            :
                            <NoInfo text="No tiene afiliaciones registradas" />
                        }
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    saleOrdersDto: state.saleorders.saleOrdersDto,
    filterCustomer: state.saleorders.filterCustomer,
    filterOrderStatus: state.saleorders.filterOrderStatus,
    filterStartDate: state.saleorders.filterStartDate,
    filterEndDate: state.saleorders.filterEndDate
});

export default connect(mapStateToProps,
    {
        fetchSaleOrders,
        updateFilterCustomer,
        updateFilterOrderStatus,
        updateFilterStartDate,
        updateFilterEndDate
    })(Sales);


// WEBPACK FOOTER //
// ./src/components/Sales/Sales.jsx